import type { ReactNode } from "react";

/**
 * Break-glass, for the same two reasons the Shopify connect popup needs one:
 *
 *  - a muted colour painted across the whole viewport, so the card in the middle
 *    reads as a card. ui-core has Panel (a card) but no page surface.
 *  - centred text *inherited* by whatever body the flow renders into the card.
 *    `T` centres one element at a time, and the bodies live in
 *    ConnectBigCommerceScreen, so the alignment has to come from an ancestor.
 */
export function BigCommerceConnectPageSurface({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-light-background p-6 text-center">
      {children}
    </div>
  );
}
